// extracted by mini-css-extract-plugin
export default {"nameSection":"nameSection-djmol","container":"container-JgLF0","limitCounter":"limitCounter-wwXLu"};